module.exports = __webpack_public_path__ + "img/GREY NON POLAR_REFLECITONS.png";